export const data_topics = [
  //topic_id, topic_name
  [1, 'Cloud'],
  [2, 'CI / CD and Provisioning'],
  [3, 'Database'],
  [4, 'Distributed Systems'],
  [5, 'Architecture & Design'],
  [6, 'Tooling'],
  [7, 'APIs and Protocols'],
  [8, 'Testing & Test Automation'],
  [9, 'Frontend Development'],
  [10, 'Agile Methods'],
  [11, 'Software Craft'],
  [12, 'Documentation'],
  [13, 'Java DI based frameworks'],
  [14, 'Performance'],
  [15, 'Security'],
  [16, 'Mobile App Development'],
  [17, 'Economical understanding'],
  [18, 'Autonomy'],
  [19, 'Responsibility for work '],
  [20, 'Coaching and Mentoring'],
  [21, 'Contact with the customer'],
  [22, 'Customer requirements'],
  [23, 'Project experience'],
  [24, 'Development of guilds '],
  [25, 'Publications'],
  [26, 'Community- and Customer Activities / Events'],
  [27, 'Communication'],
  [28, 'Servant Leadership'],
  [29, 'Personal attributes/skills'],
  [30, 'To be discussed']
]